<template>
  <common-form @submit="$utils.navigate('/symptoms')">
    <screener-frame>
      <screener-title title="Epworth Sleepiness Scale" />

      <screener-box>
        <p class="body-1">
          Using the following scale,
          choose the most appropriate number for each situation
        </p>
        <div
          v-for="({ option, label }) in epworthItems"
          :key="option"
          class="body-1"
        >
          <b>{{ option }}</b>
          - {{ label }}
        </div>
      </screener-box>

      <common-loading :loading="epworthProps.loading">
        <v-row>
          <v-col
            v-for="epworth in epworthProps.list"
            :key="epworth.epworthid"
            cols="12"
            md="6"
          >
            <v-select
              v-model="epworth.selected"
              :items="epworthItems"
              :label="epworth.epworth"
              :rules="[v => v !== -1 || 'This field is required']"
              item-value="option"
            >
              <template #selection="{ item }">
                <span class="epworth-option selected">
                  {{ item.option }} - {{ item.label }}
                </span>
              </template>
              <template #item="{ item }">
                <span class="epworth-option">
                  {{ item.option }} - {{ item.label }}
                </span>
              </template>
            </v-select>
          </v-col>
        </v-row>
      </common-loading>

      <template #actions>
        <v-spacer />

        <v-btn
          class="button-next"
          color="primary"
          type="submit"
          :loading="epworthProps.loading"
        >
          Next
          <v-icon>mdi-chevron-double-right</v-icon>
        </v-btn>
      </template>
    </screener-frame>
  </common-form>
</template>

<script>
import { onMounted } from '@vue/composition-api'
import {
  epworthProps,
  loadEpworthProps
} from '@/use/epworth'
import { epworthItems } from '@/constants'

export default {
  setup: () => {
    onMounted(loadEpworthProps)

    return {
      epworthProps,
      epworthItems
    }
  }
}
</script>
